import { z } from 'zod';
import {
  accountPermissionStatus,
  TAB_VALUES,
} from '../consts/account-permission';

const accountPermissionStatusSchema = z.enum(accountPermissionStatus);

export const accountPermissionSearchSchema = z.object({
  keyword: z.string().optional(),
  practitionerTypeCode: z.array(z.string()).optional(),
  userStatus: z
    .union([accountPermissionStatusSchema, z.literal('')])
    .optional(),
  userId: z.string().optional(),
  tab: z.enum(TAB_VALUES).optional().default('group'),
  showInactive: z.boolean().optional().default(false),
});

export type AccountPermissionSearchParams = z.infer<
  typeof accountPermissionSearchSchema
>;
